module.exports = require("./../../_gen/starling/text/TextFieldAutoSize");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/text/TextFieldAutoSize.js
// module id = 229
// module chunks = 0